/**
 * @fileoverview ESM mirror of ../crossAppDeepLinks.js.
 *
 * See the CJS source for full documentation. Drift between the two is caught by
 * `tests/unit/crossAppDeepLinks.esmParity.test.js` (behaviour) and `tests/esm/native-import.test.mjs` (names).
 *
 * @module @puffin-core/cross-app-policy/crossAppDeepLinks
 */

import { fillRoute } from '@puffin-core/route-match';
import { APP_REGISTRY } from './registry.js';
import { CROSS_APP_ROUTE_SCHEME, crossAppRoute } from './crossAppRoute.js';

const CROSS_APP_DEEP_LINKS = Object.freeze({
  prep: Object.freeze({
    ENROLLMENT: '/courses/:enrollmentId',
    ADMIN_CERTIFICATIONS: '/admin/certifications',
  }),
});

function deepLinkPattern(appKey, linkKey) {
  const links =
    typeof appKey === 'string' && Object.hasOwn(CROSS_APP_DEEP_LINKS, appKey)
      ? CROSS_APP_DEEP_LINKS[appKey]
      : null;
  if (!links) {
    throw new Error(`crossAppDeepLink: app "${appKey}" declares no deep links`);
  }
  if (typeof linkKey !== 'string' || !Object.hasOwn(links, linkKey)) {
    throw new Error(`crossAppDeepLink: app "${appKey}" has no deep link "${linkKey}"`);
  }
  return links[linkKey];
}

function crossAppDeepLink(appKey, linkKey, params) {
  return crossAppRoute(appKey, fillRoute(deepLinkPattern(appKey, linkKey), params));
}

function crossAppDeepLinkFamily(appKey, linkKey) {
  return `${CROSS_APP_ROUTE_SCHEME}${appKey}${deepLinkPattern(appKey, linkKey)}`;
}

function parseCrossAppRouteFamily(family) {
  if (typeof family !== 'string' || !family.startsWith(CROSS_APP_ROUTE_SCHEME)) return null;
  const rest = family.slice(CROSS_APP_ROUTE_SCHEME.length);
  const slash = rest.indexOf('/');
  if (slash <= 0) return null;
  const targetApp = rest.slice(0, slash);
  const pathPattern = rest.slice(slash);
  if (!Object.hasOwn(APP_REGISTRY, targetApp) || pathPattern.startsWith('//')) return null;
  return { targetApp, pathPattern };
}

export { CROSS_APP_DEEP_LINKS, crossAppDeepLink, crossAppDeepLinkFamily, parseCrossAppRouteFamily };
